export enum categoriesTypes {
  SEARCH_CATEGORIES_REQUEST = 'SEARCH_CATEGORIES_REQUEST',
  SEARCH_FIRST_CATEGORIES_REQUEST_SUCCESS = 'SEARCH_FIRST_CATEGORIES_REQUEST_SUCCESS',
  SEARCH_CATEGORIES_REQUEST_SUCCESS = 'SEARCH_CATEGORIES_REQUEST_SUCCESS',
  SEARCH_CATEGORIES_REQUEST_FAILURE = 'SEARCH_CATEGORIES_REQUEST_FAILURE',
  UPDATE_CATEGORY_FILTER_PARAMS = 'UPDATE_CATEGORY_FILTER_PARAMS',
  CHANGE_CATEGORY_FILTER_MODAL_STATUS = 'CHANGE_CATEGORY_FILTER_MODAL_STATUS',
  ACTIVATE_INACTIVATE_CATEGORIES_REQUEST = 'ACTIVATE_INACTIVATE_CATEGORIES_REQUEST',
  ACTIVATE_INACTIVATE_CATEGORIES_SUCCESS = 'ACTIVATE_INACTIVATE_CATEGORIES_SUCCESS',
  ACTIVATE_INACTIVATE_CATEGORIES_FAILURE = 'ACTIVATE_INACTIVATE_CATEGORIES_FAILURE',
  SAVE_CATEGORY_REQUEST = 'SAVE_CATEGORY_REQUEST',
  SAVE_CATEGORY_REQUEST_RESPONSE = 'SAVE_CATEGORY_REQUEST_RESPONSE',
  CLEAR_EDIT_CATEGORY_STEPPER = 'CLEAR_EDIT_CATEGORY_STEPPER',
  SET_EDIT_CATEGORY = 'SET_EDIT_CATEGORY',
  CLEAR_EDIT_CATEGORY = 'CLEAR_EDIT_CATEGORY',
};

export interface Category {
  id: number,
  name: string,
  companyId?: number,
  active: boolean,
  created_at: Date | string,
};

interface SingleFilterInfo {
  value: number,
  label: string,
  key: number,
};

export interface filterParams {
  text: string;
  names: Array<SingleFilterInfo>,
  startDate: string,
  endDate: string,
  active: boolean,
  sort: string,
};

export interface CategoriesState {
  categories: {
    data: Array<Category> | [],
    pagination: {
      total: number,
      links: [],
    },
  }
  isLoading: boolean,
  failure: boolean,
  activateInactivateFailure: boolean | null,
  filterParams: filterParams,
  filterModalIsOpen: boolean,
  saveStatus: string,
  saveError: string,
  category: Category,
};